import React from 'react';
import Heading from '@vfuk/core-heading';
import Spacing from '@vfuk/core-spacing';
import { css } from 'styled-components';
import SimpleGrid from '@vfuk/core-simple-grid';
import Block from '@vfuk/core-block';
import FeatureGrid from '../../../FeatureGrid';

type FeatureGridProps = {
  id: string;
  iconRef: string;
  name: string;
  body: {
    body: string;
  };
  linkSlug: string;
  seoEventData: {
    seoEventData: string;
  };
};

export type SectionFeatureProps = {
  data: {
    __typename?: 'ContentfulSectionFeature';
    id: string;
    name: string;
    featureGrid: FeatureGridProps[];
  };
};

const SectionFeature = ({ data }: SectionFeatureProps) => {
  const { name, featureGrid } = data;

  return (
    <>
      <Block
        css={css`
          background-color: var(--gallery);
        `}
      >
        <SimpleGrid
          columns={{
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1,
          }}
        >
          <div data-testid="feature-header">
            <Spacing spacingLevel={{ bottom: 4 }}>
              <Heading
                appearance="secondary"
                text={name}
                level={3}
                weight={2}
                justify="center"
              />
            </Spacing>
          </div>
        </SimpleGrid>
        <div className="spring spring--md">
          <SimpleGrid
            columns={{
              sm: 1,
              md: 2,
              lg: 2,
              xl: 2,
            }}
          >
            {featureGrid.map((feature, index) => (
              <FeatureGrid key={feature.id} feature={feature} index={index} />
            ))}
          </SimpleGrid>
        </div>
      </Block>
    </>
  );
};

export default SectionFeature;
